import { splitFormatedStringIntoTimeElements } from './toSeconds';

export function shortenDisplayTime(displayTimeToShorten) {
	// console.log("Time:", displayTimeToShorten);
	if (displayTimeToShorten == undefined || null) {
		return '';
	}
	if (displayTimeToShorten == '' || displayTimeToShorten == ' ') {
		return '';
	}
	var splitTime = splitFormatedStringIntoTimeElements(displayTimeToShorten);
	// console.log("SPlit:", splitTime);
	var newDisplayTime = '';
	var hasMilSec = false,
		hasSec = false,
		hasMin = false;
	if (splitTime.min != '0' && splitTime.min != '00') {
		// console.log("Test: ", splitTime.min[0]);
		if (splitTime.min[0] == '0') {
			newDisplayTime += splitTime.min[1];
		} else {
			newDisplayTime += splitTime.min;
		}
		hasMin = true;
	}
	if (splitTime.sec != '0' && splitTime.sec != '00') {
		if (hasMin) {
			newDisplayTime += ':';
		}
		if (splitTime.sec[0] == '0' && !hasMin) {
			newDisplayTime += splitTime.sec[1];
		} else {
			newDisplayTime += splitTime.sec;
		}
		hasSec = true;
	}
	if (splitTime.milSec != '0' && splitTime.milSec != '00') {
		if (hasMin && hasSec == false) {
			newDisplayTime += ':00';
		} else if (hasSec == false) {
			newDisplayTime += '0';
		}
		if (splitTime.milSec[1] == '0') {
			newDisplayTime += '.' + splitTime.milSec[0];
		} else {
			newDisplayTime += '.' + splitTime.milSec;
		}
		hasMilSec = true;
	} else {
		if (hasSec && hasMin == false && newDisplayTime.indexOf('s') == -1) {
			newDisplayTime += 's';
		}
	}
	if (!hasMilSec && !hasSec && hasMin) {
		newDisplayTime += ':00';
	}
	if (newDisplayTime == '') {
		newDisplayTime = '0';
	}
	return newDisplayTime;
}

export function shortenTime(time) {
	time = time.replace(/[a-zA-Z]/g, '');
	return shortenDisplayTime(time);
}
